import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Grid, Typography, Box, IconButton, Select, MenuItem, InputLabel,
  FormControl, Card, CardContent, CardActions, Divider
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import axios from '../../../Axiosinstance';

const BatchForm = ({ onFormSubmit }) => {
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const [formData, setFormData] = useState({
    name: '',
    intakeSize: '',
    courseId: '',
    venueId: '',
    language: '',
    days: [
      {
        date: '',
        sessions: [
          {
            session: 'session1',
            startTime: '',
            endTime: ''
          }
        ]
      }
    ]
  });

  const [venues, setVenues] = useState([]);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        const response = await axios.get('/wsq/venues/finalls');
        setVenues(response.data);
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    };

    const fetchCourses = async () => {
      try {
        const response = await axios.get('/wsq/courses/finalls');
        setCourses(response.data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    fetchVenues();
    fetchCourses();
  }, []);

  const handleChange = (e, dayIndex = null, sessionIndex = null) => {
    const { name, value } = e.target;
    if (dayIndex !== null && sessionIndex !== null) {
      const updatedDays = formData.days.map((day, i) => {
        if (i === dayIndex) {
          day.sessions[sessionIndex][name] = value;
        }
        return day;
      });
      setFormData({ ...formData, days: updatedDays });
    } else if (dayIndex !== null) {
      const updatedDays = formData.days.map((day, i) =>
        i === dayIndex ? { ...day, [name]: value } : day
      );
      setFormData({ ...formData, days: updatedDays });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleVenueChange = (e) => {
    setFormData({ ...formData, venueId: e.target.value });
  };

  const handleCourseChange = (e) => {
    const selectedCourseId = e.target.value;
    const selectedCourse = courses.find(course => course.id === selectedCourseId);
    setFormData({ ...formData, courseId: selectedCourseId });
    setAvailableLanguages(selectedCourse ? selectedCourse.languages : []);
  };

  const handleAddDay = () => {
    setFormData({
      ...formData,
      days: [...formData.days, { date: '', sessions: [{ session: 'session1', startTime: '', endTime: '' }] }]
    });
  };

  const handleRemoveDay = (dayIndex) => {
    const updatedDays = formData.days.filter((_, i) => i !== dayIndex);
    setFormData({ ...formData, days: updatedDays });
  };

  const handleAddSession = (dayIndex) => {
    const updatedDays = formData.days.map((day, i) => {
      if (i === dayIndex) {
        const newSessionNumber = day.sessions.length + 1;
        day.sessions.push({
          session: `session${newSessionNumber}`,
          startTime: '',
          endTime: ''
        });
      }
      return day;
    });
    setFormData({ ...formData, days: updatedDays });
  };

  const handleRemoveSession = (dayIndex, sessionIndex) => {
    const updatedDays = formData.days.map((day, i) => {
      if (i === dayIndex) {
        day.sessions = day.sessions.filter((_, sIndex) => sIndex !== sessionIndex);
        day.sessions = day.sessions.map((session, sIndex) => ({
          ...session,
          session: `session${sIndex + 1}`
        }));
      }
      return day;
    });
    setFormData({ ...formData, days: updatedDays });
  };

  const validateForm = () => {
    if (!formData.days[0].date || !formData.days[0].sessions[0].startTime || !formData.days[0].sessions[0].endTime) {
      return false;
    }
    for (const day of formData.days) {
      if (!day.date) return false;
      for (const session of day.sessions) {
        if (!session.startTime || !session.endTime) return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      alert('Please fill in all mandatory fields');
      return;
    }
    try {
      const response = await axios.post('/wsq/batches', formData);
      console.log('Response:', response.data);
      onFormSubmit();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCancel = () => {
    onFormSubmit();
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3, backgroundColor: '#f9f9f9', borderRadius: 3, boxShadow: 2 }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 4 }}>
        Create New Batch
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Batch Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Intake Size"
              name="intakeSize"
              type="number"
              value={formData.intakeSize}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel id="course-select-label">Course</InputLabel>
              <Select
               label=" Select Course"
                labelId="course-select-label"
                value={formData.courseId}
                onChange={handleCourseChange}
                required
              >
                {courses.map((course) => (
                  <MenuItem key={course.id} value={course.id}>
                    {course.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="language-select-label">Language</InputLabel>
              <Select
               label="Select Language "
                labelId="language-select-label"
                value={formData.language || ''}
                onChange={(e) => setFormData({ ...formData, language: e.target.value })}
                required
              >
                {availableLanguages.map((language, index) => (
                  <MenuItem key={index} value={language}>
                    {language}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="venue-select-label">Venue</InputLabel>
              <Select
               label=" Venue"
                labelId="venue-select-label"
                value={formData.venueId}
                onChange={handleVenueChange}
                required
              >
                {venues.map((venue) => (
                  <MenuItem key={venue.id} value={venue.id}>
                    {venue.place}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Schedule
            </Typography>
            <Divider />
            <Box sx={{ maxHeight: '400px', overflowY: 'auto', mt: 2 }}>
              {formData.days.map((day, dayIndex) => (
                <Card key={dayIndex} sx={{ mb: 2, backgroundColor: '#ffffff', boxShadow: 1 }}>
                  <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                      <Typography variant="h6">Day {dayIndex + 1}</Typography>
                      <IconButton onClick={() => handleRemoveDay(dayIndex)} color="error">
                        <Delete />
                      </IconButton>
                    </Box>
                    <TextField
                      label="Date"
                      name="date"
                      type="date"
                      value={day.date}
                      onChange={(e) => handleChange(e, dayIndex)}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      required
                    />
                    {day.sessions.map((session, sessionIndex) => (
                      <Box key={sessionIndex} mb={2}>
                        <Typography variant="subtitle1" gutterBottom>
                          {session.session}
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={5}>
                            <TextField
                              label="Start Time"
                              name="startTime"
                              type="time"
                              value={session.startTime}
                              onChange={(e) => handleChange(e, dayIndex, sessionIndex)}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <TextField
                              label="End Time"
                              name="endTime"
                              type="time"
                              value={session.endTime}
                              onChange={(e) => handleChange(e, dayIndex, sessionIndex)}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <IconButton onClick={() => handleRemoveSession(dayIndex, sessionIndex)} color="error">
                              <Delete />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Box>
                    ))}
                    <Button
                      variant="outlined"
                      startIcon={<Add />}
                      onClick={() => handleAddSession(dayIndex)}
                      fullWidth
                    >
                      Add Session
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddDay}
              fullWidth
              sx={{ mt: 2 }}
            >
              Add Day
            </Button>
          </Grid>
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Box display="flex" justifyContent="space-between">
          <Button variant="contained"  color="error" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default BatchForm;
